<main class="container sxkm sxkm-bg">
  <div class="row">
    <div class="col recharge">
      <h3>Parece que tenemos que recargar...</h3><img class="recharge__img" src="../../assets/img/sura-img-recargar.svg"
        alt="SURA SESSION END" />
      <p>Se ha realizado el cierre o terminado el tiempo de tu sesión.<br>Ingresa nuevamente a tu Sucursal Virtual.</p>
      <div class="recharge__button"><a class="button button-secondary" href="/">INGRESAR NUEVAMENTE</a></div>
    </div>
  </div>
</main>